import React from 'react'

type Props = {
  value: string[]
}

export const omitWithEllipsis = (a: any[] | null, length: number): string => {
  a = a ?? []
  return a.length > length
    ? `${a.splice(0, length).join(', ')}...`
    : a.join(', ')
}

const CommaSeparatedList: React.FC<Props> = (props) => {
  const { value } = props
  return <span {...props}>{omitWithEllipsis(value, 3)}</span>
}

export default CommaSeparatedList
